import { Button } from "@/components/ui/button/button";

type Props = {
	onUpdateRoomStock: () => void;
	isValid: boolean;
	isDirty: boolean;
};

export const HeaderUpdateButton = ({ onUpdateRoomStock, isValid, isDirty }: Props) => {
	return (
		<Button variant={isValid && isDirty ? "default" : "disabled"} size={"xl"} onClick={onUpdateRoomStock}>
			保存
		</Button>
	);
};
